import React from 'react';
import Hero from '../Hero/Hero';
import Products from '../Products/Products';
import About from '../About/About';
import Services from '../Services/Services';
import { SEOHead, LocalBusinessSchema, WebsiteSchema, OrganizationSchema } from '../SEO';

const HomePage: React.FC = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [LocalBusinessSchema, WebsiteSchema, OrganizationSchema]
  };

  return (
    <>
      <SEOHead
        title="Maa Saryu Agency - Premium Tiles & Sanitary Solutions in Ayodhya | Best Tiles Supplier"
        description="Leading tiles supplier in Ayodhya offering premium ceramic, porcelain & marble tiles, granite, CP fittings, bath fittings & sanitary ware. Wholesale & retail with 15+ years experience. Quality guaranteed!"
        keywords={[
          "tiles supplier ayodhya",
          "best tiles shop ayodhya", 
          "granite supplier ayodhya",
          "sanitary ware ayodhya",
          "bathroom tiles ayodhya",
          "floor tiles ayodhya",
          "ceramic tiles ayodhya",
          "porcelain tiles ayodhya",
          "marble tiles ayodhya",
          "cp fittings ayodhya",
          "bath fittings ayodhya",
          "kitchen tiles ayodhya",
          "wall tiles ayodhya",
          "tiles wholesale ayodhya",
          "tiles retail ayodhya",
          "maa saryu agency",
          "home renovation tiles",
          "commercial tiles ayodhya",
          "tiles uttar pradesh"
        ]}
        canonicalUrl="/"
        ogTitle="Maa Saryu Agency - Premium Tiles & Sanitary Solutions in Ayodhya"
        ogDescription="🏠 Premium tiles, granite & sanitary ware supplier in Ayodhya. ✅ 15+ years experience ✅ Wholesale & retail ✅ Quality guaranteed. Visit our showroom today!"
        structuredData={structuredData}
      />
      <Hero />
      <Products />
      <About />
      <Services />
    </>
  );
};

export default HomePage;
